function onMainModalClose() {
  localStorage.setItem(MAIN_MODAL_EXIT_DATE_KEY, new Date());
}

function openMainModal(imgSrc, logo) {
  const MAIN_MODAL_WIDTH = "800px";
  const MAIN_MODAL_HEIGHT = "500px";

  const modalReference = openModal(
    MAIN_MODAL_WIDTH,
    MAIN_MODAL_HEIGHT,
    onMainModalClose,
  );

  modalReference.classList.add("main-modal");

  const sideImg = document.createElement("img");
  sideImg.src = imgSrc;
  sideImg.classList.add("side-img");
  modalReference.appendChild(sideImg);

  const infoDiv = document.createElement("div");
  infoDiv.classList.add("info-wrapper");
  modalReference.appendChild(infoDiv);

  const brandLogo = document.createElement("img");
  brandLogo.classList.add("brand-logo");
  brandLogo.src = logo;
  infoDiv.appendChild(brandLogo);

  const descriptionWrapper = document.createElement("div");
  descriptionWrapper.classList.add("description-wrapper");
  infoDiv.appendChild(descriptionWrapper);

  const title = document.createElement("strong");
  title.innerHTML = "Get Notified When New Pieces Are Released.";
  descriptionWrapper.appendChild(title);

  const description = document.createElement("p");
  description.innerHTML =
    "Join the email list for early entry to upcoming releases, curated stories from behind the brand, and select News updates.";
  descriptionWrapper.appendChild(description);

  const formDiv = document.createElement("div");
  infoDiv.appendChild(formDiv);
  formDiv.classList.add("w-100");
  loadMailChimpSignupForm(formDiv);
}
const MAIN_MODAL_EXIT_DATE_KEY = "vitoso_signup_modal_date";
const MAIN_MODAL_DISPLAY_DELAY = 12000;

function openMainModalIfShould(imgSrc, logo) {
  const MODAL_HIDDEN_LENGTH_DAYS = 7;

  const storedValue = localStorage.getItem(MAIN_MODAL_EXIT_DATE_KEY);
  const nDaysAgo = new Date();
  nDaysAgo.setDate(nDaysAgo.getDate() - MODAL_HIDDEN_LENGTH_DAYS);
  const isModalVisible =
    storedValue == null || new Date(storedValue) < nDaysAgo;

  if (isModalVisible) {
    setTimeout(() => {
      if (!window.isModalOpen()) {
        openMainModal(imgSrc, logo);
      }
    }, MAIN_MODAL_DISPLAY_DELAY);
  }
}

function loadMailChimpSignupForm(targetDiv) {
  const formWrapper = document.createElement("div");
  formWrapper.id = "mc_embed_shell";
  formWrapper.classList.add("w-100", "px-5");

  const signupFormShell = document.createElement("div");
  signupFormShell.id = "mc_embed_signup";
  formWrapper.appendChild(signupFormShell);

  const form = document.createElement("form");
  form.action =
    "https://byvitoso.us11.list-manage.com/subscribe/post?u=cd691d9b6dc68065c69381e53&amp;id=2f35af0a3a&amp;f_id=0059c6e3f0";
  form.method = "post";
  form.id = "mc-embedded-subscribe-form";
  form.name = "mc-embedded-subscribe-form";
  form.classList.add("validate");
  form.target = "_blank";
  signupFormShell.appendChild(form);

  const emailFieldGroup = document.createElement("div");
  emailFieldGroup.classList.add("mc-field-group");
  const emailInput = document.createElement("input");
  emailInput.placeholder = "EMAIL (required)";
  emailInput.type = "email";
  emailInput.name = "EMAIL";
  emailInput.classList.add("required", "email");
  emailInput.id = "mce-EMAIL";
  emailInput.required = "";
  emailInput.value = "";
  emailFieldGroup.appendChild(emailInput);
  form.appendChild(emailFieldGroup);

  const nameWrapper = document.createElement("div");
  nameWrapper.classList.add(
    "w-100",
    "d-flex",
    "flex-row",
    "justify-content-between",
  );
  form.appendChild(nameWrapper);

  const firstNameFieldGroup = document.createElement("div");
  firstNameFieldGroup.classList.add("mc-field-group");
  const firstNameInput = document.createElement("input");
  firstNameInput.placeholder = "FIRST NAME";
  firstNameInput.type = "text";
  firstNameInput.name = "FNAME";
  firstNameInput.classList.add("text");
  firstNameInput.id = "mce-FNAME";
  firstNameInput.value = "";
  firstNameFieldGroup.appendChild(firstNameInput);
  nameWrapper.appendChild(firstNameFieldGroup);

  const lastNameFieldGroup = document.createElement("div");
  lastNameFieldGroup.classList.add("mc-field-group");
  const lastNameInput = document.createElement("input");
  lastNameInput.placeholder = "LAST NAME";
  lastNameInput.type = "text";
  lastNameInput.name = "LNAME";
  lastNameInput.classList.add("text");
  lastNameInput.id = "mce-LNAME";
  lastNameInput.value = "";
  lastNameFieldGroup.appendChild(lastNameInput);
  nameWrapper.appendChild(lastNameFieldGroup);

  const responses = document.createElement("div");
  responses.id = "mce-responses";
  responses.classList.add("clear");
  form.appendChild(responses);

  const responsesError = document.createElement("div");
  responsesError.id = "mce-error-response";
  responsesError.classList.add("response");
  responsesError.style.display = "none";
  responses.appendChild(responsesError);

  const responsesSuccess = document.createElement("div");
  responsesSuccess.id = "mce-success-response";
  responsesSuccess.classList.add("response");
  responsesSuccess.style.display = "none";
  responses.appendChild(responsesSuccess);

  const metaDiv = document.createElement("div");
  metaDiv.ariaHidden = "true";
  metaDiv.style.position = "absolute";
  metaDiv.style.left = "-5000px";
  const metaInput = document.createElement("input");
  metaInput.type = "text";
  metaInput.name -= "b_cd691d9b6dc68065c69381e53_2f35af0a3a";
  metaInput.tabIndex = "-1";
  metaInput.value = "";
  metaDiv.appendChild(metaInput);
  form.appendChild(metaDiv);

  const submitBtnWrapper = document.createElement("div");
  submitBtnWrapper.classList.add("clear", "w-100");
  const submitBtn = document.createElement("input");
  submitBtn.type = "submit";
  submitBtn.name = "subscribe";
  submitBtn.id = "mc-embedded-subscribe";
  submitBtn.classList.add("button", "important-btn", "w-100");
  submitBtn.value = "NOTIFY ME";
  submitBtnWrapper.appendChild(submitBtn);
  form.appendChild(submitBtnWrapper);

  targetDiv.appendChild(formWrapper);

  /** load js */
  setTimeout(() => {
    const mcScript = document.createElement("script");
    mcScript.src =
      "//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js";

    mcScript.onload = () => {
      (function ($) {
        window.fnames = new Array();
        window.ftypes = new Array();
        fnames[0] = "EMAIL";
        ftypes[0] = "email";
        fnames[1] = "FNAME";
        ftypes[1] = "text";
        fnames[2] = "LNAME";
        ftypes[2] = "text";
        fnames[4] = "PHONE";
        ftypes[4] = "phone";
        fnames[5] = "BIRTHDAY";
        ftypes[5] = "birthday";
      })(jQuery);
      var $mcj = window.jQuery.noConflict(true);
    };

    document.body.appendChild(mcScript);
  }, 100);
}
